export {AppPaypalPaymentComponent} from './app-paypal-payment/app-paypal-payment.component';
export {AppStripePaymentComponent} from './app-stripe-payment/app-stripe-payment.component';
